export const EVENTS = {
  PREINIT_SUCCESS: "PREINIT_SUCCESS",
  INIT_SUCCESS: "INIT_SUCCESS",
  GAME_LOAD_SUCCESS: "GAME_LOAD_SUCCESS",

  SOUND_CHOOSE: "SOUND_CHOOSE",

  CLOSE_GAME: "CLOSE_GAME",
  BEFORE_SPIN: "BEFORE_SPIN",
  SPIN: "SPIN",
  SKIP: "SKIP",
  FORCESTOP: "FORCESTOP",

  INFO_CLOSE_REQUEST: "INFO_CLOSE_REQUEST",
  INFO_ON_OPEN: "INFO_ON_OPEN",
  INFO_ON_CLOSE: "INFO_ON_CLOSE",

  LOW_CREDIT: "LOW_CREDIT",

  WINDOW_UNLOAD: "WINDOW_UNLOAD",
  SEND_CLOSE_MSG: "SEND_CLOSE_MSG",
};

// events.subscribe("test", async () => { console.log("3000test"); });
//
// // events.subscribe("test", async () => new Promise((res) => {
// //     setTimeout(() => { console.log(3000); res(); }, 3000);
// // }));
// //
// // events.subscribe("test", () => new Promise((res) => {
// //     setTimeout(() => { console.log(3000); res(); }, 3000);
// // }));
//
// events.dispatchAsyncAll("test").then(() => {
//     console.log("test fullfilled");
// });
